import { Component } from '@angular/core';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { IonIntlTelInputValidators } from 'src/app/shared/libs/ion-intl-tel-input/ion-intl-tel-input.directive';
import { AuthUiHelperService } from 'src/app/auth/auth.ui.helper.service';
import { LoginService } from 'src/app/auth/login/login.service';
import { CountryISO } from 'src/app/shared/enum/country-iso.enum';
import { NebulrAnonymousTranslationService } from 'src/app/shared/services/nebulr-anonymous-translation.service';
import { PHONE_INPUT_PREFERED_COUNTRIES } from 'src/app/shared/constans';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'nblocks-mfa-setup',
  templateUrl: './mfa-setup.page.html',
  styleUrls: ['./mfa-setup.page.css'],
})
export class MfaSetupPage {
  error = false;
  loading = false;
  step: 0 | 1 | 2 = 0;
  recoverCode = '';
  param = {};
  preferredCountries = PHONE_INPUT_PREFERED_COUNTRIES;
  privacyPolicyUrl: string;

  phoneInputForm = this.formBuilder.group({
    phoneInput: [
      {
        isoCode: this.getInitialUserCountryCode(),
      },
      [Validators.required, IonIntlTelInputValidators.phone],
    ],
  });

  constructor(
    private readonly loginService: LoginService,
    private readonly navCtrl: NavController,
    private readonly authUiHelperService: AuthUiHelperService,
    private readonly formBuilder: FormBuilder,
    private readonly utilService: UtilService,
    private readonly nebulrAnonymousTranslationService: NebulrAnonymousTranslationService, // Needed for translations to work properly
  ) {
    this.param = this.authUiHelperService.getYear();
    this.privacyPolicyUrl = this.authUiHelperService.getPrivacyPolicyUrl();
  }

  async nextStep(form?: NgForm): Promise<void> {
    switch (this.step) {
      case 0:
        await this.submitPhoneNumber();
        break;

      case 1:
        await this.submitMfaCode(form!);
        break;

      case 2:
        this.navCtrl.navigateRoot('auth/choose-user');
        break;
    }
  }

  async submitPhoneNumber(): Promise<void> {
    try {
      this.loading = true;
      this.error = false;

      if (!this.phoneInputForm.valid) {
        return;
      }

      const phoneNumber =
        this.phoneInputForm.value.phoneInput.internationalNumber.replace(
          /\s/g,
          '',
        );

      await this.loginService.startMfaUserSetup(phoneNumber);
      this.step = 1;
    } catch (error) {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async submitMfaCode(form: NgForm): Promise<void> {
    try {
      this.loading = true;
      this.error = false;

      const { mfaCode } = form.value;
      this.recoverCode = await this.loginService.finishMfaUserSetup(mfaCode);
      this.step = 2;
    } catch (error) {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async handleKeyUp(e: KeyboardEvent, form?: NgForm): Promise<void> {
    if (e.key === 'Enter' && form?.valid) {
      this.nextStep(form);
    }
  }

  getInitialUserCountryCode(): CountryISO {
    return this.utilService.getBrowserCountryCode();
  }
}
